import { ILinkedAudienceQuery } from '../interfaces/linked-audience.query.interface';

export class LinkedAudience {
    id: string;
    name: string;
    memberCount: number;
    lastUpdate: Date;
    breadcrumbs: string;

    constructor(linkedAudience: ILinkedAudienceQuery) {
        if (linkedAudience) {
            this.id = linkedAudience.id.toString();
            this.name = linkedAudience.name;
            this.memberCount = linkedAudience.member_count;
            this.lastUpdate = new Date(linkedAudience.last_update);
            this.breadcrumbs = linkedAudience.breadcrumbs;
        }
    }
}
